import React from "react";
import { useTranslation } from "react-i18next";

// TODO: Remove these packages
// import "core-js/stable";
// import "regenerator-runtime/runtime";

type Props = {
  handler: () => void;
  children?: React.ReactNode;

  id?: string;
  className?: string;
  action?: string;
  method?: string;
  enctype?: string;
  button_id?: string;
  button_class?: string;
  button_text?: string;
  disabled?: boolean;
};

export const Form: React.FC<Props> = ({
  children,
  id,
  className,
  action = "#",
  method = "POST",
  enctype = "multipart/form-data",
  button_id,
  button_class,
  button_text = "forms.submit",
  disabled = false,
  handler,
}) => {
  const { t } = useTranslation();

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (handler) {
      handler();
    }
  }

  return (
    <form
      id={id}
      action={action}
      method={method}
      encType={enctype}
      onSubmit={handleSubmit}
      className={className}
    >
      {children}
      {button_id && button_text ? (
        <button
          id={button_id}
          className={button_class}
          type="submit"
          disabled={disabled}
        >
          {t(button_text)}
        </button>
      ) : (
        <></>
      )}
    </form>
  );
};

export default Form;
